<div class="title">
  <h1>Upload Forms</h1>
</div>

<div style="margin-left: 10%;margin-right: 10%;">
  <div style="display: flex;" class="sc-row-margin">


    <div style="flex: 1">

      <!-- <div style="border-top: 0;"> -->
      <!-- <div style="display: flex;" style="padding-top: 3.5em;"> -->
      <div class="sc-input-label-1" style="flex: 1;font-weight: bold; font-size: 18px;">State</div>

      <!-- </div> -->
      <mat-form-field style="width: 400px;">
        <mat-select [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>
          <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id"> {{Site.SiteName}} </mat-option>
        </mat-select>
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <!-- </div> -->

    </div>

    <!-- <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">State</h4>
      <mat-form-field style="width: 400px">
        <mat-select [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>
          <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
            {{Site.SiteName}} </mat-option>
          </mat-select>
          <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
    </div> -->



    <div style="flex: 1">
      <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">Date Completed</mat-label>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <!-- <mat-label>Date Completed</mat-label> -->
        <input matInput [matDatepicker]="picker1" type="picker1" [(ngModel)]="dateCompleted" [ngModelOptions]="{standalone: true}">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="flex: 1;">
      <div class="sc-input-label-2" style="width: 300px; padding-right: 10px;">
        <div class="example-full-width" style="width: 500px;display: flex; flex-direction: row; justify-content: flex-start;">
          <div class="addfiles">
            <ng-container *ngFor="let file of FileList; let indx = index">
              <div *ngIf="getFileType(file) == 'pdf'">
                <mat-icon title="{{getFileType(file)}}" style="cursor: pointer;" (click)="DownloadForm(indx)">picture_as_pdf</mat-icon>
              </div>
              <img *ngIf="getFileType(file) != 'pdf'" style="padding-bottom: 3px; cursor: pointer;" (click)="DownloadForm(indx)" src="../../../../../../Content/Images/Icons/icons_file-24.png" alt="File" title="{{getFileType(file)}}">
            </ng-container>
          </div>
          <div class="sc-icon">
            <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">+ Add File(s) </mat-label> (.pdf, .docx, .xls)
            <input type="file" #fileUploader  name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChanged($event);" multiple>
          </div>
        </div>
      </div>

    </div>

  </div>


  <div style="display: flex;" class="sc-row-margin">

    <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">Form</h4>
      <mat-form-field *ngFor="let formCat of groupedForms" appearance="DBSS" style="width: 400px;">
        <!-- <mat-label>Form</mat-label> -->
  <!-- <mat-select matNativeControl [(ngModel)]="inputForm" required>
        <mat-optgroup *ngFor="let formCat of groupedForms" [label]="formCat.FormCategoryName">
          <mat-option *ngFor="let form of formCat.Forms" [value]="form.Id"> {{form.Name}}
          </mat-option>
        </mat-optgroup>
        </mat-select> -->
        <input matInput class="sc-input sc-date-input" type="text" [value]="formCat.Forms[0].Name" disabled />
      </mat-form-field>
    </div>

    <div style="flex: 1">
      <div style="border-top: 0;">
        <div style="display: flex;">
          <div class="sc-input-label-1" style="flex: 1;font-weight: bold; font-size: 18px;">Related User</div>
          <div class="sc-icon" style="padding-left: 10%; flex: 1; display: flex; cursor: pointer;" (click)="GetAdminLinkToAddUsers()">
            <span><b>+</b> Add User</span>
          </div>
        </div>
        <mat-form-field style="width: 400px;">
          <mat-select [(ngModel)]="relatedUser">
            <mat-option *ngFor="let usr of users" [value]="usr.UserAuto">{{usr.UserName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    <div style="flex: 1">
      <div style="display: flex;">
        <ng-container *ngFor="let img of ImageList">
          <img style="width:100px; height:100px; padding: 4px;" *ngIf="img" [src]="sanitize(img)">
        </ng-container>
        <div class="sc-icon" style="padding-left: 20px;">
          <span style="font-weight: bold; font-size: 18px;">+ Add Image(s) </span> (.png, .jpg, .jpeg)
          <input type="file" #fileUploader_ accept="image/*" (change)="onSelectPhotoAddImagetoForm($event)" multiple>
        </div>
      </div>
      <div style="display: flex; flex-wrap: wrap">
      </div>
    </div>

  </div>
  <!-- <ng-container *ngFor="let formCat of groupedForms" >   -->
  <ng-container *ngIf="RequireIncidentNo==true">
    <ng-container *ngIf="FormCategoryId==1">
      <div style="display: flex" class="sc-row-margin">
        <div style="flex: 1">
          <h4 style="font-weight: bold; font-size: 18px;" class="get-label">Report/Incident ID</h4>
          <mat-form-field style="width: 400px;">
            <input matInput [(ngModel)]="reportIncidentID" required>
          </mat-form-field>
        </div>

        <div style="flex: 1">
          <h4 style="font-weight: bold; font-size: 18px;" class="get-label">Incident Type</h4>
          <mat-form-field style="width: 400px;">
            <mat-select [(ngModel)]="incidentType">
              <mat-option *ngFor="let iType of incidentTypes" [value]="iType.Id">
                {{iType.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div style="flex: 1">


        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- </ng-container> -->

  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">Notes</h4>

      <mat-form-field style="width: 1000px; ">
        <textarea class="sc-textarea" matInput [(ngModel)]="Notes" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>

    </div>
  </div>

  <div style="display: flex" class="sc-row-margin">
    <div style="flex: 1">
      <div style="display: flex; font-weight: bold; font-size: 18px;">

        <!-- <i  class="material-icons sc-icon" >check_box</i>
        <i  class="material-icons sc-icon" style="display: none" >check_box_outline_blank</i> -->
        <mat-checkbox [(ngModel)]="isActiveFollowUpRequired">Follow Up Required</mat-checkbox>

        <!-- <div class="sc-input-label-1 sc-cbtext">Follow Up Required</div> -->
      </div>
    </div>

    <div style="flex: 1">
      <div style="display: flex;font-weight: bold; font-size: 18px;">

        <!-- <i  class="material-icons sc-icon" >check_box</i>
        <i  class="material-icons sc-icon" style="display: none" >check_box_outline_blank</i> -->
        <mat-checkbox [(ngModel)]="isActiveFollowUpCompleted">Follow Up Completed</mat-checkbox>

        <!-- <div class="sc-input-label-1 sc-cbtext">Follow Up Completed</div> -->
      </div>
    </div>
    <div style="flex: 1">
    </div>
  </div>



  <div style="display: flex;padding-top: 1.25em;" class="sc-row-margin">

    <div style="flex: 1">
      <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">Follow Up Date</mat-label>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <!-- <mat-label>Date Completed</mat-label> -->
        <input matInput [matDatepicker]="picker2" type="picker2" [(ngModel)]="fololowupDate" [ngModelOptions]="{standalone: true}">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="flex: 1">
      <div style="border-top: 0;">
        <div style="display: flex;">
          <div class="sc-input-label-1" style="flex: 1;font-weight: bold; font-size: 18px;">Follow Up User</div>
          <div class="sc-icon" style="padding-left: 10%; flex: 1; display: flex; cursor: pointer;" (click)="GetAdminLinkToAddUsers()">
            <span><b>+</b> Add User</span>
          </div>
        </div>
        <mat-form-field style="width: 400px;">
          <mat-select [(ngModel)]="fololowupUser">
            <mat-option *ngFor="let usr of users" [value]="usr.UserAuto">{{usr.UserName}}</mat-option>
          </mat-select>
          <!-- <i class="material-icons" (click)="GetAdminLinkToAddUsers()">add</i> -->
        </mat-form-field>
      </div>
    </div>
    <div style="flex: 1">

    </div>
  </div>

  <div style="display: flex" class="sc-row-margin">
    <div style="flex: 1">
      <!-- @if (updateHistory != null)
      {
          if (updateHistory.AddedByUser != null && updateHistory.DateAdded != null)
          { -->
      <div style="margin: 2px 0px">Added by: </div>
      <!-- }
          if (updateHistory.ModifiedByUser != null && updateHistory.DateModified != null)
          {
              <div style="margin: 2px 0px">Last edited by: @updateHistory.ModifiedByUser on @updateHistory.DateModified</div>
          }
      } -->
    </div>

    <div>
      <div style="display: flex;">
        <div class="buttonbelow">
          <!-- <button mat-raised-button (click)="reset()" >Reset</button>
          <button mat-raised-button (click) ="save()">Save</button>  -->
          <!-- <button mat-raised-button >Delete</button>  -->
        </div>


      </div>
    </div>
  </div>
  <!-- Question formCategories -->

  <ng-container *ngIf="QuestionCategories!=null">
    <ng-container *ngFor="let fc of QuestionCategories">
      <ng-container *ngIf="fc.Order!=0">

        <h3 title="fc.QCategoryName"><b><u>{{fc.QCategoryName}}</u></b></h3>

      </ng-container>

      <ng-container *ngFor="let q of questionsAns">
        <ng-container *ngIf="fc.QuestionCatId == q.QuestionCatId">


          <div style="display:flex;flex-direction:row;font-weight: 600;font-size: 17px;    margin-top: 3%;">
            <ng-container *ngIf="q.QCount>1">     <span>{{q.QuestionNumber}}).</span> </ng-container>
            <div title="q.QDescription">{{q.QTitle}}</div>

            <!-- <i class="material-icons sc-icon sc-icon-safe" style="margin-left: 10px;"(click) = "openAddCommentDialog(q.QuestionId,q)" >add_comment</i> -->

            <ng-container *ngIf="q.QuestionComment!=null"><i class="material-icons sc-icon sc-icon-safe" style="margin-left: 10px;" (click)="openAddCommentDialog(q.QuestionId,q)">add_comment</i></ng-container>

            <ng-container *ngIf="q.QuestionComment==null"><i class="material-icons sc-icon" style="margin-left: 10px;" (click)="openAddCommentDialog(q.QuestionId,q)">add_comment</i></ng-container>




          </div>


          <!-- <td style="width: 10%; cursor: pointer" >

          </td> -->
          <!-- <td style="text-align: center; width: 5%">
            <i class="material-icons sc-icon sc-icon-safe" (click) = "openAddCommentDialog(q.QuestionId,q)" >add_comment</i>
          </td> -->

          <div style="display:flex">

            <ng-container *ngIf="q.HasQuestionImage==true">
              <div style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2%">
                <img id="q.QuestionId" style='display:block; width: 250px;' *ngIf="q.QuestionImage" [src]="sanitize(q.QuestionImage)" />
              </div>
              <ng-container *ngIf="q.ImageEdit==true">
                <div>
                  <button data-toggle="modal" (click)="openEditImageDialog(q.QuestionImage, q.QuestionId,q)">Edit Image</button>
                </div>
                <div style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2%">
                  <!-- <ng-container *ngFor="let imag of ImageList"> -->
                  <!-- <img style="width:100px; height:100px; padding: 4px;" *ngIf="img" [src]="sanitize(img)"> -->
                  <!-- </ng-container> -->
                  <!-- <img id="q.QuestionId" style='display:none; width: 250px;' /> -->
                  <div *ngIf="q.EditedQuestionImage != '' && q.EditedQuestionImage != null"
                       style="display:flex;flex-direction:row;font-size: 14px;     margin-left: 1%;">
                    <img id="q.QuestionId" style='display:block; width: 250px;'
                         [src]="sanitize(q.EditedQuestionImage)" />
                  </div>

                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="q.ModelAnswers.length> 0">
              <ng-container *ngIf="q.QuestionTypeId != 3">

                <div style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <ng-container *ngFor="let answers of q.ModelAnswers">


                    <div style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                      <!-- <input style="min-width: 35px;" type="radio" id="q.QuestionId" name="q.QuestionId" (change)="SelectAnswer(q.QuestionId,answers.AnswerId,q.QuestionTypeId,$event)" /> -->


                      <input style="min-width: 35px;" [(ngModel)]="ModelAnswers[q.QuestionId]" [checked]="ModelAnswers[q.QuestionId]" value="{{q.QuestionId}}-{{answers.AnswerId}}" (change)="SelectAnswer(q.QuestionId,answers.AnswerId,q.QuestionTypeId,$event)" type="radio"
                             name="answers{{q.QuestionId}}">

                      <label type="text" style="min-width: fit-content;" name="setup-question-name"> {{answers.Answer}}</label>

                    </div>
                  </ng-container>
                  <!-- <mat-radio-button *ngFor="let answers of q.ModelAnswers" [value]="answers"  (change)="SelectAnswer(q.QuestionId,answers.AnswerId,q.QuestionTypeId,$event)"
                  [checked]="answers.select">

                  <span>{{answers.Answer}}</span></mat-radio-button> -->

                </div>

              </ng-container>
              <ng-container *ngIf="q.QuestionTypeId == 3">

                <div style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <ng-container *ngFor="let answers of q.ModelAnswers">

                    <div style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2% ; margin-top: 1%;">
                      <input style="min-width: 35px;" type="checkbox" id="check_{{answers.AnswerId}}" (change)="SelectAnswer(q.QuestionId,answers.AnswerId,q.QuestionTypeId,$event)" />
                      <label type="text" name="setup-question-name" style="width: 100px;min-width: fit-content;"> {{answers.Answer}}</label>
                    </div>

                  </ng-container>
                </div>



              </ng-container>

            </ng-container>
            <ng-container *ngIf="q.ModelAnswers.length == 0">
              <!-- else
              { -->
              <ng-container *ngIf="q.QuestionTypeId == 4">


                <div style="flex-direction:row;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <textarea style="min-width:600px; height:125px;" id="freetext_{{q.QuestionId}}" type="text" (change)="AddValue(q.QuestionId,q.QuestionTypeId,$event)"></textarea>


                </div>
              </ng-container>
              <!-- else
              { -->
              <ng-container *ngIf="q.QuestionTypeId == 5">

                <div style="flex-direction:row;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                  <input type="number" id="numerical_{{q.QuestionId}}" (change)="AddValue(q.QuestionId,q.QuestionTypeId,$event)" />
                </div>
              </ng-container>
              <!-- } -->
              <!-- } -->
            </ng-container>
            <!-- comment box -->
            <!-- <div
              style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 1%; margin-left: auto;margin-right: auto;">
              <textarea style="width: 400px; margin: auto;"  rows="4" [(ngModel)]="QuestionComment"
                maxlength="256" placeholder="Comment"></textarea>

            </div> -->
            <!-- comment box -->








          </div>

          <ng-container *ngIf="q.AllowImages==true">

            <div style="flex: 1 0 67%">
              <!-- <div>

                   <div style="padding-left: 8px; flex: 1; display: flex;">
                       <div  class="sc-icon">
                           <i class="material-icons">add</i>
                           <span style="padding-left: 8px;">Add Image</span>
                       </div>
                       <input type="file"   style="visibility: hidden;"
                               accept=".jpg,.jpeg,.gif,.png,.bmp" />
                   </div>
               </div>
               <div style="display: flex; flex-wrap: wrap">

               </div>
              -->


              <div style="padding-left: 8px; flex: 1; display: flex;">
                <div *ngIf=" q.UploadImages!=null">
                  <ng-container *ngFor="let img of q.UploadImages">
                    <img style="width:100px; height:100px; padding: 4px;" *ngIf="img!=null" ng-if="renderImage" [src]="sanitize_(img)">

                  </ng-container>
                  <span style="min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"><i class="material-icons sc-icon" (click)="delete(img,q)">delete</i></span>
                </div>


                <div class="sc-icon">
                  <i class="material-icons">add</i>
                  <span style="padding-left: 8px;  font-size: 15px;">Add Image</span>
                  <input type="file" #fileUploader_ accept="image/*" (change)="onSelectPhoto($event, q)">
                </div>
              </div>
              <div style="display: flex; flex-wrap: wrap">
              </div>

            </div>
          </ng-container>


        </ng-container>
      </ng-container>

    </ng-container>
  </ng-container>
  <!-- end question categories -->
  <div class="loader-wrapper" *ngIf="savingForm">
    <mat-spinner></mat-spinner>
  </div>
  <div>
    <div>
      <div class="buttonbelow" style="display: flex; flex-direction: row;">
        <div style="padding-right: 10px;">

        </div>
        <div style="padding-right: 10px;">
          <button mat-raised-button (click)="reset()">Reset</button>
        </div>
        <div>
          <button mat-raised-button color="warn" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>

</div>
